import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { useSelector } from "react-redux";

import { Button } from "@/components/Common";
import { Form, Input } from "@/components/Form";
import { Row, Col } from "@/components/Grid";
import api, { makeOptions } from "@/services/api";
import toastify from "@/services/toastify";

import { ModalContent, ModalBody, ModalFooter } from "./styles";

export default function ModalEditComissao({ onClose, franqueado }) {
  const { data: user } = useSelector(state => state.auth);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(null);

  const schema = Yup.object().shape({
    comissao: Yup.number()
      .required("Obrigatório!")
      .min(0, "Comissão deve ser maior ou igual a 0")
      .max(100, "Comissão deve ser menor ou igual a 100")
      .typeError("Digite um valor numérico válido"),
    comissao_adesao: Yup.number()
      .required("Obrigatório!")
      .min(0, "Comissão de adesão deve ser maior ou igual a 0")
      .max(100, "Comissão de adesão deve ser menor ou igual a 100")
      .typeError("Digite um valor numérico válido"),
  });

  useEffect(() => {
    if (franqueado) {
      setFormData({
        comissao: franqueado.comissao || 0,
        comissao_adesao: franqueado.comissao_adesao || 0,
      });
    } else {
      setFormData(null);
    }
  }, [franqueado]);

  useEffect(() => {
    if (!loading) {
      // Modal será fechado via onClose() no handleSubmit se sucesso
    }
  }, [loading]);

  async function handleSubmit(data) {
    try {
      setLoading(true);
      const endpoint = `franqueados/${franqueado.id}`;
      const { data: response } = await api.put(
        endpoint,
        {
          comissao: data.comissao,
          comissao_adesao: data.comissao_adesao,
        },
        makeOptions(user)
      );

      if (response.success) {
        toastify("Comissões atualizadas com sucesso!");
        setLoading(false);
        onClose();
        window.location.reload(true);
      } else {
        toastify("Erro ao atualizar comissões", "error");
        setLoading(false);
      }
    } catch (error) {
      toastify("Erro ao atualizar comissões", "error");
      setLoading(false);
    }
  }

  return (
    <ModalContent>
      {formData && franqueado && (
        <Form
          key={franqueado.id}
          schema={schema}
          onSubmit={handleSubmit}
          initialData={formData}
        >
          <ModalBody>
            <h2>Editar Comissões - {franqueado?.nome}</h2>
            <Row hascols>
              <Col>
                <Input
                  name="comissao"
                  label="Comissão (%)"
                  type="number"
                  step="0.01"
                  min="0"
                  max="100"
                />
              </Col>
              <Col>
                <Input
                  name="comissao_adesao"
                  label="Comissão Adesão (%)"
                  type="number"
                  step="0.01"
                  min="0"
                  max="100"
                />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              type="submit"
              variant="tangerine"
              loading={loading || undefined}
            >
              Salvar
            </Button>
            <Button
              type="button"
              variant="cancel"
              onClick={() => onClose()}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </Form>
      )}
    </ModalContent>
  );
}
